import axios from 'axios';
import environment from '@src/environment';

export const state = {
  copiedLink: null,
};

export const mutations = {
  setShareableLink(state, value) {
    state.copiedLink = value;
  },
};

export const actions = {
  async generateMealShareUrl(ctx, payload) {
    return await axios.post(`${environment.GENERATE_MEAL_SHARE_URL}`, payload).then((res) => res.data.shareLink);
  },
  async generateRecipeShareUrl(ctx, payload) {
    return await axios.post(`${environment.GENERATE_RECIPE_SHARE_URL}`, payload).then((res) => res.data.shareLink);
  },
};
